import React from "react";

import { isDefined } from "@utils/helpers";

import { useStoreDirectionsContext } from "../../storeDirections.context";
import { StoreDirectionsResultComponent } from "./storeDirectionsResult.component";
import { StoreDirecitonsResultSkeleton } from "./storeDirectionsResult.skeleton";

type StoreDirectionsResultProps = {};

export const StoreDirectionsResult = ({}: StoreDirectionsResultProps) => {
    const { storeName, origin, distance, resetOrigin } =
        useStoreDirectionsContext();

    if (!isDefined(distance) || !isDefined(origin?.label)) {
        return (
            <StoreDirecitonsResultSkeleton onChangeOriginClick={resetOrigin} />
        );
    }

    return (
        <StoreDirectionsResultComponent
            distance={distance}
            originLabel={origin.label}
            storeName={storeName}
            onChangeOriginClick={resetOrigin}
        />
    );
};
